export default class ConfirmLeave {
  private popupForm: HTMLElement;

  private closeBtn: HTMLElement;

  private closeModalBtns: HTMLCollectionOf<HTMLElement>;

  private confirmLeaveBtn: HTMLElement;

  private destinationUrl: string;

  private currentUrl: string;

  constructor() {
    this.popupForm = document.getElementsByClassName('js-popup')[0] as HTMLElement;
    this.closeBtn = document.getElementsByClassName('js-closePopupBtn')[0] as HTMLElement;
    this.confirmLeaveBtn = document.getElementsByClassName('js-confirmLeave')[0] as HTMLElement;
    this.closeModalBtns = document.getElementsByClassName('js-closeModal') as HTMLCollectionOf<HTMLElement>;
    this.destinationUrl = (document.getElementsByClassName('js-destination')[0] as HTMLInputElement).value;
    this.currentUrl = window.location.href;
    window.addEventListener('popstate', () => {
      this.popupForm.classList.remove('is-hidden');
      this.pushHistory();
    });
    this.pushHistory();
    this.pushHistory();
  }

  onClickClose(): void {
    this.closeBtn.addEventListener('click', e => {
      e.preventDefault();
      this.popupForm.classList.add('is-hidden');
      this.pushHistory();
    });

    this.popupForm.addEventListener('click', e => {
      const clickedOverlay = e.target === this.popupForm;
      if (clickedOverlay) this.popupForm.classList.add('is-hidden');
    });
  }

  onClickModalClose(): void {
    for (let i = 0; i < this.closeModalBtns.length; i++) {
      const closeModalBtn = this.closeModalBtns[i];
      closeModalBtn.addEventListener('click', e => {
        e.preventDefault();
        this.popupForm.classList.remove('is-hidden');
        this.pushHistory();
      });
    }
  }

  onClickConfirm(): void {
    this.confirmLeaveBtn.addEventListener('click', () => {
      window.location.href = this.destinationUrl;
    });
  }

  pushHistory(): void {
    const { history } = window;
    history.pushState({ turbolinks: false, url: this.currentUrl }, '', this.currentUrl);
  }
}
